import * as Yup from "yup";

export type SearchBrokerageAgentTeamValidationInput = {
  licenseType: string;
  officeId?: string;
  teamMemberId?: string;
};

export type SearchBrokerageAgentTeamFieldErrors = {
  search?: string;
  office?: string;
  teamMember?: string;
};

function normalizeLicenseType(licenseType: string) {
  const lt = String(licenseType || "").trim().toUpperCase();
  if (lt === "TEAM_MEMBER") return "BROKERAGE_TEAM_MEMBER";
  return lt;
}

export function requiresSearchBrokerageOffice(licenseType: string) {
  const lt = normalizeLicenseType(licenseType);
  return lt === "BROKERAGE_FIRM" || lt === "BROKERAGE_TEAM_MEMBER";
}

export function requiresSearchBrokerageTeamMember(licenseType: string) {
  // Team Member is optional for now. Keep the old requirement commented so it can be restored later.
  // return normalizeLicenseType(licenseType) === "BROKERAGE_FIRM";
  return false;
}

export function getSearchBrokerageAgentTeamFieldErrors(
  input: SearchBrokerageAgentTeamValidationInput
): SearchBrokerageAgentTeamFieldErrors {
  const lt = normalizeLicenseType(input.licenseType);
  const officeId = String(input.officeId ?? "").trim();
  const teamMemberId = String(input.teamMemberId ?? "").trim();
  const errors: SearchBrokerageAgentTeamFieldErrors = {};

  if (requiresSearchBrokerageOffice(lt) && !officeId) {
    errors.office = "Office is required";
  }
  // Team Member is optional for now. Uncomment this block if it becomes required again.
  // if (requiresSearchBrokerageTeamMember(lt) && !teamMemberId) {
  //   errors.teamMember = "Team Member is required";
  // }

  return errors;
}

export function validateSearchBrokerageAgentTeamSelection(
  input: SearchBrokerageAgentTeamValidationInput
): { valid: boolean; errors: SearchBrokerageAgentTeamFieldErrors } {
  const errors = getSearchBrokerageAgentTeamFieldErrors({
    licenseType: input.licenseType,
    officeId: String(input.officeId ?? "").trim(),
    teamMemberId: String(input.teamMemberId ?? "").trim(),
  });
  return { valid: Object.keys(errors).length === 0, errors };
}

/** Yup schema when license type, office, and team member ids are validated together. */
export const searchBrokerageAgentTeamSelectionSchema = Yup.object({
  licenseType: Yup.string().required(),
  officeId: Yup.string().when("licenseType", {
    is: (value: string) => requiresSearchBrokerageOffice(value),
    then: (schema) => schema.trim().required("Office is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  teamMemberId: Yup.string().when("licenseType", {
    // Team Member is optional for now. Restore requiresSearchBrokerageTeamMember when needed.
    // is: (value: string) => requiresSearchBrokerageTeamMember(value),
    // then: (schema) => schema.trim().required("Team Member is required"),
    is: () => false,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) => schema.notRequired(),
  }),
});
